import { SecureApi } from '../../core/secure.api';
import { Injectable } from '@angular/core';
@Injectable()
export class PDFsService {
    constructor(public secureApi: SecureApi) {
    }

    url = 'support-center-pdf';
    all(language) {
        return this.secureApi.get(this.url + '/index/' + language);
    }

    /**
     * @param pdfId
     * @param languageCode
     * @param {string} clinicId
     * @returns {Observable<any>}
     */
    read(pdfId, languageCode, clinicId = '') {
        if (!pdfId || !languageCode) {
            return;
        }

        return this.secureApi.get(this.url + '/read/' + pdfId + '/' + languageCode);
    }

    /**
     * @param videoId
     * @param videoForm
     * @param videoModel
     * @returns {Observable<any>}
     */
    upload(pdf, language) {
        if (!pdf) {
            return;
        }

        const url = this.url + '/upload-pdf/' + language;
        return this.secureApi.post(url, pdf, false);
    }

    /**
     * @param pdfId
     * @param pdfForm
     * @param pdfModel
     * @returns {Observable<any>}
     */
    save(id, pdfForm, language) {
        let url = this.url + '/create';
        if (!id) {
            return this.secureApi.post(url, pdfForm, false);
        }
        url = this.url + '/update/' + id + '/' + language;
        return this.secureApi.put(url, pdfForm, false);
    }

    /**
     * Search template content
     *
     * @param {string} searchTerm
     * @returns {Observable<any>}
     */
    search(searchTerm: string) {
        if (!searchTerm) {
            return;
        }
    }

    /**
     * @param index
     * @param newIndex
     * @returns {Observable<any>}
     */
    order(list, index, newIndex, language) {
        if (!list.length) {
            return;
        }
        return this.secureApi.post(this.url + '/order/' + language, { currentList : list, index: index, newIndex: newIndex}, false);
    }
}
